module.exports = __webpack_public_path__ + "img/honghe.dc0d946f.png";